<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15"><i class="el-icon-back mr-r4 c-pointer" v-if="selectedHost != null" @click="clickBackButton"></i>VM 및 템플릿 목록</div>
        <!-- <w-group-save-button class="mr-r4" :disabled="checkedRows.length == 0" managetype-id="VMS"
        :rsc-event-rule-list="ruleInfo.rscEventRuleList" :event-alarm-rule-list="ruleInfo.eventAlarmRuleList" @group-save="groupSave"/> -->
        <el-button class="mr-r15" :disabled="checkedRows.length === 0" @click="clickDeleteButton">장비 삭제</el-button>
        <span class="mr-r5">관리여부</span>
        <!-- 0429 수정 -->
        <div class="setting-addel" style="height:29px">
          <el-button size="mini" @click="AllCheckChangeButtonClick('1')"><i class="fas fa-check-square"></i></el-button>
          <el-button size="mini" @click="AllCheckChangeButtonClick('0')"><i class="far fa-square"></i></el-button>
        </div>
      </div>
      <div class="vertical-center-box">
        <el-checkbox v-model="lastThreeDaysFlag" @change="onChangeThreeFlag">최근 3일 이내 등록된 장비  <em>{{recentRegisteredDeviceCount}}개</em></el-checkbox>
        <el-button class="mr-r4" type="primary" @click="clickSaveButton" :disabled="!cellEditing.isModified">저장</el-button>
        <el-button class="mr-r4" @click="loadData" :disabled="!cellEditing.isModified">취소</el-button>
        <w-header-pagination class="mr-r4" :pagination="pagination" @current-change="handlerHeaderCurrentChange"></w-header-pagination>
        <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-row>
      <el-table-wrapper :data="tableData" :columns="tableColumns" :column-default="columnDefault" ref="vmTable"
       :editable="true" :pagination="true" :show-search-tool="showSearchTool" :show-custom-header="true" @condition-change="changeTableCondition"
       @selection-change="changeCheckedRow" @pagination-change="handlerPaginationChange" @total-change="handlerPaginationChange" @cell-dblclick="startEdit" remote :total="total">
        <template slot-scope="scope" slot="switch-slot">
           <w-switch-editor :disabled="scope.row.objDeletedFlag === '1'" :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" active-value="1" inactive-value="0" @cell-edit-end="editTwoStatusCell" />
        </template>
        <template slot-scope="scope" slot="input-slot">
          <w-input-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" @cell-edit-end="endEdit">
            <span slot="content">{{ getTableValueAfterCheckEmpty(scope.row, scope.column, scope.row[scope.column.property]) }}</span>
          </w-input-editor>
        </template>
        <template slot-scope="scope" slot="delete-flag-slot">
           <el-checkbox v-model="scope.row.objDeletedFlag" disabled true-label="1" false-label="0"></el-checkbox>
        </template>
        <template slot-scope="scope" slot="checkbox-slot">
          <w-checkbox-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" true-label="1" false-label="0" @cell-edit-end="editTwoStatusCell" />
        </template>
        <template slot-scope="scope" slot="rsc-rule-slot">
          <w-select-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" :list="ruleInfo.rscEventRuleList"
            keyField="ruleTmplId" labelField="ruleTmplName" valueField="ruleTmplId" @cell-edit-end="endEdit" />
        </template>
        <template slot-scope="scope" slot="event-rule-slot">
          <w-select-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" :list="ruleInfo.eventAlarmRuleList"
            keyField="ruleTmplId" labelField="ruleTmplName" valueField="ruleTmplId" @cell-edit-end="endEdit"/>
        </template>
      </el-table-wrapper>
    </el-row>
  </div>
</template>

<script>
import { cloneDeep, isNil, isEmpty } from 'lodash';

import DeviceRegistrationVmsAPI from '@/api/settings/common/device-registration-vms';

import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';
import { columnDefault, defaultPagination } from '@/constants/table';

import WHeaderPagination from '@/components/table/HeaderPagination';
import CellEditingMixin from '@/mixins/table/cell-editing';
import WInputEditor from '@/components/table/cell-editor/InputEditor';
import WSelectEditor from '@/components/table/cell-editor/SelectEditor';
import WCheckboxEditor from '@/components/table/cell-editor/CheckboxEditor';
import WSwitchEditor from '@/components/table/cell-editor/SwitchEditor';
import WGroupSaveButton from '@/views/settings/basic/DeviceRegistration/components/GroupSaveButton';

const pagination = cloneDeep(defaultPagination);

export default {
  name: 'WVirtualMachine',
  components: {
    WHeaderPagination,
    WInputEditor,
    WSelectEditor,
    WCheckboxEditor,
    WSwitchEditor,
    WGroupSaveButton,
  },
  mixins: [CellEditingMixin],
  props: {
    activeTab: String,
    selectedVirtualcenter: Number,
    ruleInfo: Object,
    selectedHost: Object,
  },
  data() {
    return {
      pagination,
      columnDefault,
      isLoading: false,
      showSearchTool: false,
      total: 0,
      tableData: [],
      checkedRows: [],
      lastThreeDaysFlag: false,
      recentRegisteredDeviceCount: 0,
      loadFromThreeDataFlag: false,
      tableColumns: [
        {
          // align: 'center',
          type: 'selection',
        },
        {
          prop: 'objManagementApplyFlag',
          label: '관리여부',
          editable: true,
          // align: 'center',
          scopedSlot: 'switch-slot',
          width: 85,
          filters: [
            {
              text: '관리',
              value: '1',
            },
            {
              text: '비관리',
              value: '0',
            },
          ],
        },
        // 전원상태 미표현으로 인해 주석처리
        // {
        //   prop: 'VVM_COMMON/ALIVE',
        //   label: '전원 상태',
        //   formatter: this.getTableValueAfterCheckEmpty,
        //   width: 90,
        //   filters: [
        //     {
        //       text: '켜짐',
        //       value: '켜짐',
        //     },
        //     {
        //       text: '꺼짐',
        //       value: '꺼짐',
        //     },
        //   ],
        // },
        {
          prop: 'vmName',
          label: 'VM 명',
          searchable: true,
        },
        {
          prop: 'vmDesc',
          label: '별칭',
          scopedSlot: 'input-slot',
          searchable: true,
          editable: true,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          formatter: this.getTableValueAfterCheckEmpty,
          searchable: true,
        },
        {
          prop: 'VVM_COMMON/OS',
          label: '운영체제',
          formatter: this.getTableValueAfterCheckEmpty,
          searchable: true,
        },
        {
          prop: 'VVM_COMMON/CPU_CORE_TOTAL_COUNT',
          label: 'CPU 수',
          formatter: this.getTableValueAfterCheckEmpty,
          width: 70,
        },
        {
          prop: 'vmTemplateFlag',
          label: '템플릿 여부',
          formatter: (row, column, value) => (value === '1' ? '템플릿' : 'VM'),
          width: 100,
          filters: [
            {
              text: 'VM',
              value: '0',
            },
            {
              text: '템플릿',
              value: '1',
            },
          ],
        },
        {
          prop: 'objDeletedFlag',
          label: '삭제 여부',
          width: 80,
          align: 'center',
          scopedSlot: 'delete-flag-slot',
        },
        {
          prop: 'eventExceptFlag',
          label: '이벤트 제외',
          width: 90,
          align: 'center',
          editable: true,
          scopedSlot: 'checkbox-slot',
        },
        {
          prop: 'rscEventRuleId',
          label: '수집/판단정책',
          scopedSlot: 'rsc-rule-slot',
          editable: true,
          searchable: true,
          remoteProp: 'rscEventRuleName',
        },
        {
          prop: 'eventAlarmRuleId',
          label: '이벤트/알람정책',
          scopedSlot: 'event-rule-slot',
          editable: true,
          searchable: true,
          remoteProp: 'eventAlarmRuleName',
        },
        {
          prop: 'registDatetime',
          label: '장비 등록일',
          width: 130,
          align: 'center',
          formatter: this.getDateFormatter,
          searchable: true,
          searchType: 'date',
        },
      ],
    };
  },
  watch: {
    selectedHost(host) {
      if (!isNil(host)) {
        this.$refs.vmTable.clearFilter();
        this.loadData();
      }
    },
  },
  methods: {
    /**
     * VM 리스트 로드
     * @author jeee12
     */
    loadData() {
      if (isNil(this.selectedVirtualcenter)) return;

      const tableParams = this.$refs.vmTable.getParameter();
      const params = { virtualcenterGroupId: this.selectedVirtualcenter, objtypeId: 'VVM' };
      if (!isNil(this.selectedHost)) {
        params.hostVmsObjId = this.selectedHost.vmsObjId;
      }
      // '최근 3일 이내 등록된 장비' 클릭 시 start 값이 기존 값으로 남아있는 문제 인지, 초기화 추가
      if (this.loadFromThreeDataFlag) {
        params.start = 0;
      }
      DeviceRegistrationVmsAPI.getRecentRegisteredDeviceCount(params).then((response) => {
        this.recentRegisteredDeviceCount = response.data.data;
      });
      this.isLoading = true;
      this.loadFromThreeDataFlag = false;
      DeviceRegistrationVmsAPI.getVirtualObjList({
        lastThreeDaysFlag: this.lastThreeDaysFlag,
        attrInfoParams: [
          // 전원 상태 미표현으로 인해 주석처리
          // { attrTypeId: 'VVM_COMMON', attrId: 'ALIVE' },
          { attrTypeId: 'VVM_COMMON', attrId: 'OS' },
          { attrTypeId: 'VVM_COMMON', attrId: 'CPU_CORE_TOTAL_COUNT' },
        ],
        ...params,
        ...tableParams,
      }).then((response) => {
        this.total = response.data.total;
        this.tableData = this.getEditableTableData(response.data.data, this.tableColumns);
        this.resetCellEditing();
      }).finally(() => {
        this.isLoading = false;
      });
    },
    /**
     * 저장버튼 클릭
     * @author jeee12
     */
    clickSaveButton() {
      const updatedData = this.getUpdatedDatas(this.tableData, true, ['objId', 'vmsObjId', 'ipaddress', 'objName', 'objCompanyId']);
      const target = '관리 대상';
      const action = msgUtil.action.SAVE;

      DeviceRegistrationVmsAPI.updateVirtualDeviceList({ objtypeId: 'VVM', virtualDeviceList: updatedData }).then((response) => {
        const result = response.data;
        if (result.success) {
          this.loadData();
        }
        this.$message(msgUtil.getResultMsgData(action, target, result.success));
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
    /**
     * 테이블 selection change
     * @author jeee12
     */
    changeCheckedRow(selection) {
      this.checkedRows = selection;
    },
    /**
     * 선택된 VM 삭제
     * @author jeee12
     */
    clickDeleteButton() {
      const target = '관리 대상';
      const action = msgUtil.action.DELETE;
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        DeviceRegistrationVmsAPI.deleteVirtualDeviceList({ virtualDeviceList: this.checkedRows }).then((response) => {
          const result = response.data;
          if (result.success) {
            this.loadData();
          }
          this.$message(msgUtil.getResultMsgData(action, target, result.success));
        });
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
    /**
     * 데이터 포맷터
     * @author jeee12
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 테이블 헤더 검색 조건 change
     * @author jeee12
     */
    changeTableCondition() {
      this.loadData();
    },
    /**
     * 관리여부 전체 선택/해제
     * @author jeee12
     * @param  {Bool} objManagementApplyFlag 관리여부 true/false
     */
    AllCheckChangeButtonClick(objManagementApplyFlag) {
      const result = this.editDirectBulk(this.tableData, 'objManagementApplyFlag', objManagementApplyFlag);
      this.tableData = result.tableData;
      this.completeEditBulk(...result);
    },
    /**
     * 뒤로가기 버튼 클릭
     * @author jeee12
     */
    clickBackButton() {
      this.$emit('click-back-button');
    },
    handlerPaginationChange(_pagination) {
      this.pagination = _pagination;
    },
    handlerHeaderCurrentChange(_currentPage) {
      this.$refs.vmTable.setCurrentPage(_currentPage);
    },
    handlerEndEdit() {
      this.checkExistModifiedData(this.tableData);
    },
    onChangeThreeFlag() {
      this.loadFromThreeDataFlag = true;
      this.$nextTick(() => {
        this.$refs.vmTable.setCurrentPage(1);
      });
    },
    groupSave(data) {
      if (!isEmpty(data)) {
        const checkedRows = cloneDeep(this.checkedRows);
        const updatedData = checkedRows.map((item) => Object.assign({}, item, data));
        const target = '관리 대상';
        const action = msgUtil.action.SAVE;
        DeviceRegistrationVmsAPI.updateVirtualDeviceList({ objtypeId: 'VVM', virtualDeviceList: updatedData }).then((response) => {
          const result = response.data;
          if (result.success) {
            this.loadData();
          }
          this.$message(msgUtil.getResultMsgData(action, target, result.success));
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      }
    },
  },
};
</script>

<style module>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Virtual/components/VirtualMachine.vue